import PropTypes from 'prop-types';
import Formatter from '../lib/Formatter';

Currency.propTypes = {
  currency: PropTypes.oneOfType([PropTypes.string,PropTypes.number]),
};

export default function Currency({currency}) {
  return (
    <span>{ Formatter.currency(currency) }</span>
  );
}